import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    toolbar: {
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "center"
    },
    table: {
      borderBottom: "1px solid #9c9c9c"
    },
    tableHeader: {
      backgroundColor: "rgb(5, 89, 141)",
      "& .MuiTableCell-root": {
        color: "#fff !important",
        fontWeight: "bold"
      }
    },
    row: {
      backgroundColor: "#fff"
    }
  })
);
